import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Container,
  Toolbar,
  Typography,
} from '@mui/material';
import {
  LocalShipping as VehicleIcon,
  ReceiptLong as PermitIcon,
  Map as RouteIcon,
  Description as DocTypeIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import TypeManager from '../components/TypeManager';
import { useOrg } from '../context/OrgContext';

function TypesManagement() {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);
  const orgContext = useOrg();
  const orgDefaultDuration = orgContext?.org?.settings?.default_permit_duration_days || 365;

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Toolbar sx={{ pl: 0, pr: 0, mb: 3 }}>
        <Typography variant="h5" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
          {t('typesManagement.pageTitle')}
        </Typography>
      </Toolbar>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
          <Tab
            icon={<PermitIcon sx={{ mr: 1 }} />}
            label={t('typesManagement.permitTypesTab')}
            iconPosition="start"
          />
          <Tab
            icon={<VehicleIcon sx={{ mr: 1 }} />}
            label={t('typesManagement.vehicleTypesTab')}
            iconPosition="start"
          />
          <Tab
            icon={<RouteIcon sx={{ mr: 1 }} />}
            label={t('typesManagement.routesTab')}
            iconPosition="start"
          />
          <Tab
            icon={<DocTypeIcon sx={{ mr: 1 }} />}
            label={t('typesManagement.documentTypesTab')}
            iconPosition="start"
          />
        </Tabs>
      </Box>

      <Box role="tabpanel" hidden={tabValue !== 0}>
        {tabValue === 0 && (
          <TypeManager
            title={t('typesManagement.permitTypeSingular')}
            endpoint="/permit-types/"
          />
        )}
      </Box>

      <Box role="tabpanel" hidden={tabValue !== 1}>
        {tabValue === 1 && (
          <TypeManager
            title={t('typesManagement.vehicleTypeSingular')}
            endpoint="/vehicle-types/"
            defaultDurationDays={orgDefaultDuration}
          />
        )}
      </Box>

      <Box role="tabpanel" hidden={tabValue !== 2}>
        {tabValue === 2 && (
          <TypeManager
            title={t('typesManagement.routeSingular')}
            endpoint="/routes/"
          />
        )}
      </Box>

      <Box role="tabpanel" hidden={tabValue !== 3}>
        {tabValue === 3 && (
          <TypeManager
            title={t('typesManagement.documentTypeSingular')}
            endpoint="/document-types/"
          />
        )}
      </Box>
    </Container>
  );
}

export default TypesManagement;
